import React, { useMemo } from 'react';

import { orderBy } from 'lodash';

import useUserHook from 'hooks/useUserHook';

import { useProjectTreeStore } from 'store/projectContract.store';

import { useQueryGetStoredTags } from 'api/queries/getStoredTags.query';

import { Select } from 'components/DesignSystem/Select';

export const TagsFilter = ({ value, onChange }) => {
    const { customerId } = useUserHook();
    const { project, contract } = useProjectTreeStore();
    const { data: tagsList } = useQueryGetStoredTags({
        enabled: true,
        customerId,
        projectId: project?.id,
        contractId: contract?.id,
    });

    const options = useMemo<ISelectOption<number>[]>(
        () =>
            tagsList
                ? orderBy(
                      tagsList.map((item) => ({ label: item.name, value: item.tagId })),
                      [(item) => item.label.toLowerCase()],
                      ['asc'],
                  )
                : [],
        [tagsList],
    );

    return (
        <Select<ISelectOption<number>, true>
            value={options.filter((item) => value.includes(item.value))}
            options={options}
            onChange={onChange}
            isMulti={true}
        />
    );
};
